export default {
  title: 'Ønsker du å slette dette bildet?',
  text: 'Dette kan ikke angres og bildet blir slettet for alltid.',
  deny: 'Behold bildet',
  confirm: 'Slett bildet',
};
